export enum SORT_COLUMNS {
  NAME_EN = "WorkerFirstName",
  NAME_AR = "WorkerFullNameArabic",
  NATIONALITY = "WorkerNationality",
  JOB_TITLE_EN = "WorkerJobTitle",
  JOB_TITLE_AR = "WorkerJobTitleArabic",
  RESIDENCY_AR = "ResidencyAr",
  COMPANY = "CompanyAr",
  STATUS = "WorkerOnboardingStatus",
}

export enum SORT_DIRECTION {
  ASC = "asc",
  DESC = "desc",
}

export const FILTER_APPLY_TIMEOUT_MS = 500;
